<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    /><path
      d="M17.619 20.001a1 1 0 01-1-1v-2.21a1 1 0 011-1H21.5a1 1 0 011 1v2.21a1 1 0 01-1 1zm-7.559 0a1 1 0 01-1-1v-2.21a1 1 0 011-1h3.88a1 1 0 011 1v2.21a1 1 0 01-1 1zm-7.56 0a1 1 0 01-1-1v-2.21a1 1 0 011-1h3.88a1 1 0 011 1v2.21a1 1 0 01-1 1zm15.119-5.9a1 1 0 01-1-1v-2.207a1 1 0 011-1H21.5a1 1 0 011 1v2.207a1 1 0 01-1 1zm-7.559 0a1 1 0 01-1-1v-2.207a1 1 0 011-1h3.88a1 1 0 011 1v2.207a1 1 0 01-1 1zm-7.56 0a1 1 0 01-1-1v-2.207a1 1 0 011-1h3.88a1 1 0 011 1v2.207a1 1 0 01-1 1zm15.119-5.9a1 1 0 01-1-1v-2.2a1 1 0 011-1H21.5a1 1 0 011 1v2.21a1 1 0 01-1 1zm-7.559 0a1 1 0 01-1-1v-2.2a1 1 0 011-1h3.88a1 1 0 011 1v2.21a1 1 0 01-1 1zM2.5 8.21a1 1 0 01-1-1V5.001a1 1 0 011-1h3.88a1 1 0 011 1v2.21a1 1 0 01-1 1z"
      fill="currentColor"
    />
  </g>
</template>